import {
  Component,
  ChangeDetectionStrategy,
  HostBinding,
  ElementRef,
  AfterContentInit,
  OnDestroy,
  signal,
  input,
  contentChild
} from "@angular/core";

@Component({
  selector: "av-control-row",
  templateUrl: "./control-row.component.html",
  styleUrls: ["./control-row.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ControlRowComponent implements AfterContentInit, OnDestroy {
  readonly type = input<"switch" | "text" | "button" | "card" | "radio">(undefined);
  readonly label = input<string>(undefined);
  readonly help = input<string>(undefined);
  readonly inline = input<boolean>(undefined);
  readonly inlineFlex = input<number>(undefined);

  @HostBinding("class") get class() {
    return {
      ["type-" + this.type()]: true,
      inline: this.inline(),
      ["inline-flex-" + this.inlineFlex()]: this.inline() && this.inlineFlex(),
    };
  }

  readonly rowLabel = contentChild("[row-label]", { read: ElementRef });

  private observer?: MutationObserver;
  protected hasLabelProjected = signal(false);

  constructor() {}

  ngAfterContentInit(): void {
    // Observe content changes
    const rowLabel = this.rowLabel();
    if (!rowLabel) return;
    this.observer = new MutationObserver(() => this.checkContent());
    this.observer.observe(rowLabel.nativeElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private checkContent() {
    this.hasLabelProjected.set(
      this.rowLabel()?.nativeElement.innerHTML.trim().length > 0
    );
  }

  get isHelpProjected() {
    return !["card", "button"].includes(this.type());
  }
}
